import React, { Component } from 'react';

import getMyMap, {createAreasMassLayer, createNamesLayer, createCommuneMassLayer,
  createCommunesNamesLayerEasy, getLegendMode} from '../b-LeafletMap/leaflet_map';

import {c_missing_data, c_gradient_reds_greens} from '../a-Graphic/Colors';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValues from '../b-LeafletMap/Legend/LegendValues';

class WorkPlaces extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: "median_income",
      legend_label: "(revenu disponible par mois par unité de consommation du ménage)"
    };

    this.mode = "work_ratio"
    this.colors = c_gradient_reds_greens.slice(2, 8)
  }

  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* WORK AREAS */
    var areas_by_reason = this.props.territory.areas_by_reason;
    var work_areas = areas_by_reason.filter((abr)=>abr["name"]=="work")[0]["areas"];
    work_areas = work_areas.filter((wa)=> communes_names.includes(wa.name))
    var work_areas_coords = work_areas.map((a) => a.coords)
    var work_areas_masses = work_areas.map((a) => a.mass)
    var work_areas_labels = work_areas.map((a) => '<span class="small-text">' + a.name + "</span></br>" + a.mass + " emplois")

    let work_areas_sorted = work_areas.sort((a, b)=> b.mass - a.mass)
    let names_work_areas = work_areas_sorted.slice(0, 15)
    let names_work_areas_coords = names_work_areas.map((a) => a.coords)
    let names_work_areas_labels = names_work_areas.map((a) => a.name)


    var communes_masses = communes.map((c) => Math.round(work_areas.filter((wa)=>wa.name==c.name)[0].mass/c.status.employed*100));
    var communes_labels = communes.map((c) => c.name + "</br>" + c.status.employed + " actifs - " + work_areas.filter((wa)=>wa.name==c.name)[0].mass + " emplois</br>" +
                                              "Ratio emploi/actif.ves : " + Math.round(work_areas.filter((wa)=>wa.name==c.name)[0].mass/c.status.employed*100) + "%");


    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = this.communes_layer = createCommuneMassLayer(mymap, communes, communes_masses, communes_labels, this.mode, this.colors);
    var areas_layer = this.areas_layer = createAreasMassLayer(mymap, work_areas_coords, work_areas_masses, work_areas_labels);
    createCommunesNamesLayerEasy(mymap, communes)
    //var names_layer = this.names_layer = createNamesLayer(mymap, names_work_areas_coords, names_work_areas_labels);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
    var communes = this.props.territory.communes;
    var areas_by_reason = this.props.territory.areas_by_reason;
    var work_areas = areas_by_reason.filter((abr)=>abr["name"]=="work")[0]["areas"];
    var c_masses = communes.map((c) => Math.round(work_areas.filter((wa)=>wa.name==c.name)[0].mass/c.status.employed*100));

    var [intervals, colors] = getLegendMode(this.mode, c_masses, this.colors);

    var ratio_territory = Math.round(this.props.territory.jobs_nb/this.props.territory.pop_status.employed * 100);

    return(
          <div className="row align-items-end">
            <div className="col-10">
              <div style={{height: "500px"}} id={this.props.id}></div>
            </div>
            <div className="col-2 pl-0 pr-0">
                 {/*<p className="mb-5">Globalement, le territoire a un ratio emploi/actif.ves de {ratio_territory}%.</p>*/}
                 <LegendCommune label="(ratio emploi/actif.ves - %)"/>
                 <LegendValues intervals={intervals} colors={colors}/>
                 <div className="mt-4"></div>
                 <LegendClusterArea grey={true} label="Nombre d'emplois dans la commune"/>
            </div>
          </div>

    )
  }
}

export default WorkPlaces;
